import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress, Snackbar, Stack, Typography } from '@mui/material';
import LicenseIcon from '@mui/icons-material/CardMembership';
import { useUserContext } from '../hooks/useUserContext';
import ProfileInfoCard from '../components/profile/ProfileInfoCard';
import SectionCard from '../components/profile/SectionCard';
import EducationCard from '../components/profile/EducationCard';
import WorkHistoryCard from '../components/profile/WorkHistoryCard';
import InterestsCard from '../components/profile/InterestsCard';
import AccountCard from '../components/profile/AccountCard';

export default function Profile() {
  const { loading } = useUserContext();
  const [snackMessage, setSnackMessage] = useState<string | null>(null);

  const notify = (message: string) => setSnackMessage(message);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Stack spacing={3}>
      {/* Header */}
      <Box>
        <Typography variant="h4" sx={{ color: 'text.primary', mb: 1 }}>
          My Profile
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          View and manage your account information
        </Typography>
      </Box>

      <ProfileInfoCard notify={notify} />
      <SectionCard
        icon={<LicenseIcon />}
        title="Licenses"
        subtitle="Your CPA licenses and their CPE requirements are managed on the License Management page."
        action={
          <Button component={RouterLink} to="/app/licenses" variant="outlined" size="small">
            Manage Licenses
          </Button>
        }
      >
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Add or edit state licenses, and confirm the CPE requirements tracked for each one.
        </Typography>
      </SectionCard>
      <EducationCard notify={notify} />
      <WorkHistoryCard notify={notify} />
      <InterestsCard notify={notify} />
      <AccountCard />

      <Snackbar
        open={!!snackMessage}
        autoHideDuration={5000}
        onClose={() => setSnackMessage(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setSnackMessage(null)} severity="success" variant="filled" sx={{ width: '100%' }}>
          {snackMessage}
        </Alert>
      </Snackbar>
    </Stack>
  );
}
